import {create} from 'zustand';
import {RequestAtomType} from '../../types';
import {UseRequestDataStoreProps} from './types';

export const useRequestDataStore = create<UseRequestDataStoreProps>(set => ({
	data: {} as RequestAtomType,
	setData: data => set({data}),
	resetData: () => set({data: {} as RequestAtomType}),
}));
